import { ExtraExpense } from "./extra-expense";

export class ExtraExpenseJob {
    id:number = 0;
    extra_expense_id: number = 0;
    register_day: number = 1;
    active: boolean = true;
    extraExpense: ExtraExpense = null;
}
